import { render } from "./ShadowTeamView.vue?vue&type=template&id=c8a4b2c4"
import script from "./ShadowTeamView.vue?vue&type=script&lang=js"
export * from "./ShadowTeamView.vue?vue&type=script&lang=js"

import "./ShadowTeamView.vue?vue&type=style&index=0&id=c8a4b2c4&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__